import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { saveNewsletter } from "../actions/contact";
import { tempAlWait } from "../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";

class Footer extends React.Component {
    state = {
        email: '',
        name: '',
        confirm: false,
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.redSaveNews != prevProps.redSaveNews) {
            this.setState({
                alert: this.props.redSaveNews.alert
            })
        }

        if (this.state.alert != prevState.alert) {
            this.props.changeAlert(this.state.alert);
        }
    }

    handleSave(el) {
        el.preventDefault();

        if (this.state.confirm == false) {
            alert('Veuillez cocher la case "Oui, je souhaite m\'abonner à la newsletter."');
        } else {
            this.props.saveNewsletter({name: this.state.name, email: this.state.email});
            this.setState({
                alert: tempAlWait()
            })
        }
    }
    render() {
        return <footer className="ftr dispAdmin">
            <h2 className="ftr__ttl">{this.props.idtt.name}</h2>
            <div className="ftr__infos">
                {/** Formulaire **/}
                <form className="ftr__zoneform">
                    <h3 className="ftr__subttl">Restez connectés avec nous</h3>
                    <div className="ftr__formgrp">
                        <label htmlFor="form-prenom" className="ftr__formlab">Prénom *</label>
                        <input
                            type="text"
                            className="ftr__forminp"
                            id="form-prenom"
                            required
                            value={this.state.name}
                            onChange={(el) => this.setState({name: el.target.value})}
                        />
                    </div>
                    <div className="ftr__formgrp">
                        <label htmlFor="email" className="ftr__formlab">E-mail *</label>
                        <input
                            type="email"
                            className="ftr__forminp"
                            id="form-mail"
                            required
                            value={this.state.email}
                            onChange={(el) => this.setState({email: el.target.value})}
                        />
                    </div>
                    <button type="button" className="checkbox" id="form-newsletter" onClick={() => this.setState({confirm: !this.state.confirm})}>
                        <div className="checkbox__box">
                            <span className={`checkbox__check ${this.state.confirm && "checkbox__check--active"}`}><FontAwesomeIcon icon={faCheck} /></span>
                        </div>
                        <span className="checkbox__lab">Oui, je souhaite m'abonner à la newsletter.</span>
                    </button>
                    <button title="Je m'inscris à la newsletter" aria-label="Je m'inscris à la newsletter" id="btn-newsletter" className="ftr__formbtn" onClick={(el) => this.handleSave(el)}>
                        Envoyer
                    </button>
                </form>
                {/** Liens **/}
                <ul className="ftr__links">
                    <li className="ftr__linkitem">
                        <a href={`https://${this.props.idtt.slug}.fr`} className="ftr__link" title={`Accéder au site internet de ${this.props.idtt.name}`} aria-label={`Accéder au site internet de ${this.props.idtt.name}`}>
                            www.{this.props.idtt.slug}.fr
                        </a>
                    </li>
                    <li className="ftr__linkitem">
                        <a href={`mailto:contact@${this.props.idtt.slug}.fr`} target="_blank" title={`Envoyer un mail à ${this.props.idtt.name}`} aria-label={`Envoyer un mail à ${this.props.idtt.name}`} className="ftr__link">
                            contact@{this.props.idtt.slug}.fr
                        </a>
                    </li>
                </ul>
                {/** Mentions légales **/}
                <ul className="ftr__mentsleg">
                    <li className="ftr__linkitem">
                        <a href="/politique-de-confidentialite" className="ftr__link ftr__link--lit" title="Accéder aux politiques de confidentialité" aria-label="Accéder aux politiques de confidentialité">
                            Politique de confidentialité
                        </a>
                    </li>
                    <li className="ftr__linkitem">
                        <a href="/conditions-generales" className="ftr__link ftr__link--lit" title="Accéder aux conditions générales" aria-label="Accéder aux conditions générales">
                            Conditions générales
                        </a>
                    </li>
                </ul>
            </div>
        </footer>
    }
}

const mapStateToProps = state => {
    return {
        redSaveNews: state.redSaveNews
    }
}

const mapDispatchToProps = {
    saveNewsletter
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer);